import { createIconComponent } from './createIconComponent';
import { glyphs } from './glyphs';

/**
 * The LeafyGreen system icons are a clear and concise set of glyphs designed to be minimal in form and express a variety of use-cases for all digital products.
 */
export const Icon = createIconComponent(glyphs);
